/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * PaypalexpressTryagainTrigger Input Action
 */
export class PaypalexpressTryagainTriggerInput implements Msdyn365.IActionInput {
    // PaypalexpressTryagainTrigger: Construct the input needed to run the action
    constructor() {}

    // PaypalexpressTryagainTrigger: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `PaypalexpressTryagainTrigger`;
    public getCacheObjectType = () => 'PaypalexpressTryagainTrigger';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

// PaypalexpressTryagainTrigger: Create a data model here or import one to capture the response of the action
export interface IPaypalexpressTryagainTriggerData {
    buttonClicked: boolean;
    orderSubmitClick: boolean;
}

/**
 * PaypalexpressTryagainTrigger: Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new PaypalexpressTryagainTriggerInput();
};

/**
 * PaypalexpressTryagainTrigger: Use this function to call your action and process the results as needed
 */
async function action(input: PaypalexpressTryagainTriggerInput, ctx: Msdyn365.IActionContext): Promise<IPaypalexpressTryagainTriggerData> {
    // const apiSettings = Msdyn365.msdyn365Commerce.apiSettings;

    // PaypalexpressTryagainTrigger: Uncomment the below line to get the value from a service
    // const response = await Msdyn365.sendRequest<IPaypalexpressTryagainTriggerData[]>('/get/example/id/1', 'get');
    return { buttonClicked: false, orderSubmitClick: false};
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IPaypalexpressTryagainTriggerData>>action,
    // PaypalexpressTryagainTrigger: Give your data action a unique id
    id: 'PaypalexpressTryagainTrigger',
    input: createInput
    // PaypalexpressTryagainTrigger: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
